var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{attrs:{"route":_vm.getModuleRoute,"addProperties":{
    eventType: 1,
    routeToCreate: _vm.getModuleRoute,
  },"tableProperties":_vm.tableProperties,"exportProperties":{
    pdf: {
      filename: `${_vm.$t('inventory.supplyings')}_${_vm.dateToday}.pdf`,
      route: `${_vm.getModuleRoute}/pdf`,
    },
    xls: {
      filename: `${_vm.$t('inventory.supplyings')}_${_vm.dateToday}.xlsx`,
      route: `${_vm.getModuleRoute}/excel`,
    },
  },"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.farms2'),
      data: 'farms',
      property: 'name',
      minWidth: 200,
    },
    {
      columnLabel: _vm.$t('inventory.article_category'),
      data: 'article_categories',
      property: 'name',
      minWidth: 200,
    },
    {
      columnLabel: _vm.$t('inventory.articles'),
      data: 'articles',
      property: 'name',
      minWidth: 200,
    },
    {
      columnLabel: _vm.$t('common_words.associated_companies2'),
      data: 'businesses',
      property: 'name',
      minWidth: 200,
    },
  ],"showProperties":_vm.showProperties},on:{"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue,"refresh":_vm.refresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }